import { render, staticRenderFns } from "./NewsCenterDetails5.vue?vue&type=template&id=3a3d5ead&scoped=true"
import script from "./NewsCenterDetails5.vue?vue&type=script&lang=js"
export * from "./NewsCenterDetails5.vue?vue&type=script&lang=js"
import style0 from "./NewsCenterDetails5.vue?vue&type=style&index=0&id=3a3d5ead&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a3d5ead",
  null
  
)

export default component.exports